module.exports = __webpack_public_path__ + "media/categories/81-322b666e.png";